import { render, staticRenderFns } from "./NonIndividualTab.vue?vue&type=template&id=6038659c&scoped=true&"
import script from "./NonIndividualTab.vue?vue&type=script&lang=js&"
export * from "./NonIndividualTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6038659c",
  null
  
)

export default component.exports